import api from "./index"

import { LANGS } from "types/shared";
import { IGetContentKeywordsQueryParams, IGetContentTypesQueryParams, IUpdateClientKeywordsBodyParams, IUpdateAdminKeywordsBodyParams, IUpdateTypeContentBodyParams } from "types/content"

const getLanguages = () => api.get("/content/getLanguages")

const getAllLanguages = () => api.get("/content/getAllLanguages")

const getKeywords = (lang: LANGS) => api.get(`/content/${lang}`)

const getClientKeywords = (lang: LANGS, params: IGetContentKeywordsQueryParams) => {
  const { pageIndex, pageSize, sortBy, search } = params
  
  let query = `pageIndex=${pageIndex}&pageSize=${pageSize}&sortBy=${sortBy}`

  if(search !== undefined) {
    query += `&search=${search}`
  }

  return api.get(`/content/getClientContentKeywords/${lang}?${query}`)
}

const getAdminKeywords = (lang: LANGS, params: IGetContentKeywordsQueryParams) => {
  const { pageIndex, pageSize, sortBy, search } = params
  
  let query = `pageIndex=${pageIndex}&pageSize=${pageSize}&sortBy=${sortBy}`

  if(search !== undefined) {
    query += `&search=${search}`
  }

  return api.get(`/content/getAdminContentKeywords/${lang}?${query}`)
}

const getContentTypes = (params: IGetContentTypesQueryParams) => {
  const { search } = params

  let query = ""

  if(search !== undefined) {
    query += `&search=${search}`
  }

  return api.get(`/content/getTypeContent/?${query}`)
}

const updateClientKeywords = (lang: LANGS, data: IUpdateClientKeywordsBodyParams) =>
  api.post(`/content/updateClientContentKeywords/${lang}`, data)

const updateAdminKeywords = (lang: LANGS, data: IUpdateAdminKeywordsBodyParams) =>
  api.post(`/content/updateAdminContentKeywords/${lang}`, data)

const updateTypeContent = (data: IUpdateTypeContentBodyParams) =>
  api.post("/content/updateTypeContent", data)
 
export default {
  getLanguages,
  getAllLanguages,
  getKeywords,
  getClientKeywords,
  getAdminKeywords,
  getContentTypes,
  updateClientKeywords,
  updateAdminKeywords,
  updateTypeContent
}